import React, { useEffect, useState } from "react";
import { api, extractFirstUrl } from "../lib/api";

// Module-level cache so we don't re-unfurl the same URL on every render/mount.
const cache = new Map();

export const LinkPreview = ({ text, className = "" }) => {
  const url = extractFirstUrl(text);
  const [data, setData] = useState(url && cache.has(url) ? cache.get(url) : null);

  useEffect(() => {
    if (!url) { setData(null); return; }
    if (cache.has(url)) { setData(cache.get(url)); return; }
    let alive = true;
    api.get(`/link-preview?url=${encodeURIComponent(url)}`)
      .then(({ data }) => {
        const d = data && data.url ? data : null;
        cache.set(url, d);
        if (alive) setData(d);
      })
      .catch(() => { cache.set(url, null); if (alive) setData(null); });
    return () => { alive = false; };
  }, [url]);

  if (!url || !data) return null;

  return (
    <a href={data.url} target="_blank" rel="noopener noreferrer" data-testid="link-preview"
      className={`mt-2 block border-2 border-black rounded-xl overflow-hidden bg-spotter-cream hover:bg-white transition-colors brand-shadow-sm ${className}`}>
      {data.image && (
        <img src={data.image} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }}
          className="w-full max-h-56 object-cover border-b-2 border-black" />
      )}
      <div className="p-3">
        <div className="text-[11px] uppercase tracking-wide text-spotter-maroon/60 font-bold truncate" data-testid="link-preview-domain">{data.site_name || data.domain}</div>
        <div className="font-heading font-bold text-spotter-maroon leading-snug line-clamp-2" data-testid="link-preview-title">{data.title}</div>
        {data.description && <div className="text-xs text-spotter-maroon/80 mt-1 line-clamp-2">{data.description}</div>}
      </div>
    </a>
  );
};
